/**
 * The cold boot's order, from the stored sessions to the first render (`index.tsx`).
 *
 * I-1380 (SQ-1, `docs/concept-mobile-app.md`): the session check is asked for ahead of the launch's
 * code. I-2561: the first screen's chrome (`loadLaunchChunks`: the phone chrome, the shell's runtime
 * and addresses) is fetched once the check is out, not before it, so the check never queues behind
 * those chunks on six connections. The first render still waits for the chrome, which is what it
 * draws first.
 */
export interface IBootSteps {
  /** The stored sessions (the desktop's, the shell's Keychain) and the reader's language. */
  sessions: () => Promise<unknown>;
  /** A tab holding an as-if view loads its UI before the first render; nothing otherwise. */
  asIfUi: () => Promise<unknown> | undefined;
  /** Sends the session check (and the launch's first data with it), once the sessions are back. */
  startSession: () => void;
  /** What the first screen draws of the phone chrome and the app shell. */
  launchChunks: () => Promise<unknown>;
  /** The first render, and everything that follows it. */
  render: () => void;
}

export function bootThenRender(steps: IBootSteps): Promise<void> {
  return steps
    .sessions()
    .then(() => steps.asIfUi())
    .then(() => steps.startSession())
    .then(() => steps.launchChunks())
    .finally(() => steps.render())
    .then(() => undefined);
}
